import { render } from "./EasyHeader.vue?vue&type=template&id=65c737e8&scoped=true"
const script = {}

import "./EasyHeader.vue?vue&type=style&index=0&id=65c737e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c737e8"]])

export default __exports__